import {LifecycleManager} from "./_base-lifecycles";

import removeEmptyPTags from "../global/cleanup-p-tags";
import lazy_load_event_form_iframes from "../global/lazy-loading";
import initSmoothScrollLinks from "../global/smooth-scroll-links";
import setCustomProperties from "../global/set-css-custom-props";
import preloadImages from "../global/preload-images";
import preventLinksInEditor from "../editor/prevent-links-in-editor";
import {initializeSlider, initializeSliderEditor } from "../components/slider";
import {localAdminBarUpdater} from "../utility/utils";
import {initializeNav} from "../components/nav";
import { InitializeGSAPOnPageLoad } from "../utility/init-gsap";

/**************************************************
 Event Definitions
 **************************************************/
const EVENTS = Object.freeze({
    /**
     * This event is called first thing in the editor and main.js files
     * @type {Symbol<'Initialize'>}
     */
    INIT: Symbol('Initialize'),
    /**
     * This event is called when the document is ready in the editor and main.js files
     * @type {Symbol<'Document Ready'>}
     */
    DOCUMENT_READY:Symbol('Document Ready'),
    /**
     * This event is called on the window `load` event in the editor and main.js files
     * @type {Symbol<'Window Load'>}
     */
    WINDOW_LOAD:Symbol('Window Load'),
    /**
     * This event is called once all images have loaded in the main.js file
     * @type {Symbol<'Page Loaded'>}
     */
    PAGE_LOADED:Symbol('Page Loaded'),
})


/**************************************************
   Main Lifecycle
 **************************************************/
const MainLifecycleManager = new LifecycleManager();


MainLifecycleManager
    .registerEvent(EVENTS.DOCUMENT_READY, removeEmptyPTags)
    .registerEvent(EVENTS.DOCUMENT_READY, initSmoothScrollLinks)
    .registerEvent(EVENTS.DOCUMENT_READY, setCustomProperties)
    .registerEvent(EVENTS.DOCUMENT_READY, initializeNav)
    .registerEvent(EVENTS.DOCUMENT_READY, InitializeGSAPOnPageLoad)
    
MainLifecycleManager
    .registerEvent(EVENTS.WINDOW_LOAD, initializeSlider)
    .registerEvent(EVENTS.WINDOW_LOAD, preloadImages)



MainLifecycleManager
    .registerEvent(EVENTS.PAGE_LOADED, localAdminBarUpdater)
    .registerEvent(EVENTS.DOCUMENT_READY, lazy_load_event_form_iframes)



/**************************************************
 Editor Lifecycle
 **************************************************/
const EditorLifecycleManager = new LifecycleManager();

EditorLifecycleManager
    .registerEvent(EVENTS.DOCUMENT_READY, preventLinksInEditor)
    // .registerEvent(EVENTS.DOCUMENT_READY, initializeSliderEditor)



export {
    EVENTS,
    MainLifecycleManager,
    EditorLifecycleManager
}